import {useState, useEffect, useContext,useRef} from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import styles from '../styles';
import withStyles from '@mui/styles/withStyles';
import PageHeader from '../helper/PageHeader';
import { useHistory, useLocation } from 'react-router'


function AdminBlankCertificate(props){

    const history = useHistory()

    const clickViewCertificate = () => {

        
        history.push('/dashboard/downloadUserCertificate/' + 'testId' , {
            certID: '',
            certDate: ''
        } )
    }

    return (
        <>
        <PageHeader
                title={"Generate Blank Certificate"}
            />

            <Button variant="contained" color="primary" onClick={clickViewCertificate}>Download Blank Certificate</Button>
        
        </>
    );
}

export default withStyles(styles, { withTheme: true })(AdminBlankCertificate);